import {
    CREATE_GENERAL_DC_INWARD_DETAILS_FAILURE_DK,
    CREATE_GENERAL_DC_INWARD_DETAILS_REQUEST_DK,
    CREATE_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_GENERAL_DC_INWARD_DETAILS_DK,
    DELETE_GENERAL_DC_INWARD_DETAILS_FAILURE_DK,
    DELETE_GENERAL_DC_INWARD_DETAILS_REQUEST_DK,
    DELETE_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_GENERAL_DC_INWARD_DETAILS_FAILURE_DK,
    FETCH_SINGLE_GENERAL_DC_INWARD_DETAILS_REQUEST_DK,
    FETCH_SINGLE_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK,
    FETCH_GENERAL_DC_INWARD_DETAILS_FAILURE_DK,
    FETCH_GENERAL_DC_INWARD_DETAILS_REQUEST_DK,
    FETCH_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK,
    GENERAL_DC_INWARD_DETAILS_USERFORM_RESET_DK,
    UPDATE_GENERAL_DC_INWARD_DETAILS_FAILURE_DK,
    UPDATE_GENERAL_DC_INWARD_DETAILS_REQUEST_DK,
    UPDATE_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK,
    FETCH_GENERAL_DC_INWARD_DETAILS_BY_ID_REQUEST_DK,
    FETCH_GENERAL_DC_INWARD_DETAILS_BY_ID_SUCCESS_DK,
    GENERAL_DC_INWARD_DETAILS_DC_DETAILS_DISABLED_DK,
    FETCH_PREVIOUS_GENERAL_DC_INWARD_DETAILS_REQUEST_DK,
    FETCH_PREVIOUS_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK,
    FETCH_PREVIOUS_GENERAL_DC_INWARD_DETAILS_FAILURE_DK,

} from './generalDCInwardDetails.actionsType';

export const GENERAL_DC_INWARD_DETAILS_DK = 'generalDCInwardDetailsDK';

let initialState = {
    loading: false,
    generalDCInwardDetailsById: [],
    generalDCInwardDetails: [],
    previousGetList: [],
    isDCDetailsDisabled:[],
    generalDCInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0
    },
    selectedGeneralDCDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let generalDCInwardDetailsDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_GENERAL_DC_INWARD_DETAILS_REQUEST_DK:
        case FETCH_PREVIOUS_GENERAL_DC_INWARD_DETAILS_REQUEST_DK:
        case FETCH_GENERAL_DC_INWARD_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_GENERAL_DC_INWARD_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_GENERAL_DC_INWARD_DETAILS_REQUEST_DK:
        case UPDATE_GENERAL_DC_INWARD_DETAILS_REQUEST_DK:
        case DELETE_GENERAL_DC_INWARD_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalDCInwardDetails: updatePayload
            };
        case FETCH_GENERAL_DC_INWARD_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalDCInwardDetailsById: updatePayload
            };
            case FETCH_PREVIOUS_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK:
                return {
                    ...state,
                    loading: false,
                    previousGetList: updatePayload?.GPDC
                };
        case CREATE_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalDCInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isDCDetailsDisabled:false,
            };
        case FETCH_SINGLE_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedGeneralDCDetails: updatePayload,
                generalDCInwardDetailsForm: { ...updatePayload }
            };
        case UPDATE_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedGeneralDCDetails: {},
                generalDCInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isDCDetailsDisabled:false,
            };
        case DELETE_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalDCInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isDCDetailsDisabled:false,
                selectedGeneralDCDetails: {}
            };

        case FETCH_GENERAL_DC_INWARD_DETAILS_FAILURE_DK:
        case FETCH_PREVIOUS_GENERAL_DC_INWARD_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_GENERAL_DC_INWARD_DETAILS_FAILURE_DK:
        case CREATE_GENERAL_DC_INWARD_DETAILS_FAILURE_DK:
        case UPDATE_GENERAL_DC_INWARD_DETAILS_FAILURE_DK:
        case DELETE_GENERAL_DC_INWARD_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_GENERAL_DC_INWARD_DETAILS_DK:
            return {
                ...state,
                loading: false,
                generalDCInwardDetailsForm: {
                    ...state.generalDCInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
            case GENERAL_DC_INWARD_DETAILS_DC_DETAILS_DISABLED_DK:
                return {
                    ...state,
                    isDCDetailsDisabled: payload
                };
        case GENERAL_DC_INWARD_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                generalDCInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isDCDetailsDisabled:false,
                selectedGeneralDCDetails: {}
            };
        default:
            return state;
    }
};
